(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../_util/vantEvent'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../_util/vantEvent'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vantEvent);
    global.vantTouch = mod.exports;
  }
})(this, function (exports, _vantEvent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TouchMixin = undefined;


  var MIN_DISTANCE = 10;

  function getDirection(x, y) {
    if (x > y && x > MIN_DISTANCE) {
      return 'horizontal';
    }

    if (y > x && y > MIN_DISTANCE) {
      return 'vertical';
    }

    return '';
  }

  var TouchMixin = exports.TouchMixin = {
    data: function data() {
      return { direction: '' };
    },


    methods: {
      touchStart: function touchStart(event) {
        this.resetTouchStatus();
        this.startX = event.touches[0].clientX;
        this.startY = event.touches[0].clientY;
      },
      touchMove: function touchMove(event) {
        var touch = event.touches[0];
        this.deltaX = touch.clientX - this.startX;
        this.deltaY = touch.clientY - this.startY;
        this.offsetX = Math.abs(this.deltaX);
        this.offsetY = Math.abs(this.deltaY);
        this.direction = this.direction || getDirection(this.offsetX, this.offsetY);
      },
      resetTouchStatus: function resetTouchStatus() {
        this.direction = '';
        this.deltaX = 0;
        this.deltaY = 0;
        this.offsetX = 0;
        this.offsetY = 0;
      },


      // avoid Vue 2.6 event bubble issues by manually binding events
      // https://github.com/youzan/vant/issues/3015
      bindTouchEvent: function bindTouchEvent(el) {
        var onTouchStart = this.onTouchStart,
            onTouchMove = this.onTouchMove,
            onTouchEnd = this.onTouchEnd;


        (0, _vantEvent.on)(el, 'touchstart', onTouchStart);
        (0, _vantEvent.on)(el, 'touchmove', onTouchMove);

        if (onTouchEnd) {
          (0, _vantEvent.on)(el, 'touchend', onTouchEnd);
          (0, _vantEvent.on)(el, 'touchcancel', onTouchEnd);
        }
      }
    }
  };
});